import React from "react";
import { NavLink } from "react-router";
import logo from './image/logo.png';
import style from "./index.module.scss";

const NavBar = () => {
  return (
    <header>
        <img src={logo} alt="融达融资担保"></img>
        <nav>
            <NavLink to="/" className={({ isActive }) => (isActive ? style.active : "")}>
                首页
            </NavLink>
            <NavLink to="/scope-business" className={({ isActive }) => (isActive ? style.active : "")}>
                业务范围
            </NavLink>
            <NavLink to="/about-us" className={({ isActive }) => (isActive ? style.active : "")}>
                关于我们
            </NavLink>
            <NavLink to="/connect-us" className={({ isActive }) => (isActive ? style.active : "")}>联系我们</NavLink>
        </nav>
    </header>
  );
};

export default NavBar;
